export default "__VITE_ASSET__C3V8ZT10__"